export default __webpack_public_path__ + "static/media/center_bushes.c093c783.svg";